import {styleRule, StyleSheet} from "../../../../../../stem-core/src/ui/Style.js";
import {registerStyle} from "../../../../../../stem-core/src/ui/style/Theme.js";
import {UI} from "../../../../../../stem-core/src/ui/UIBase.js";
import {SubscriptionOfferStore} from "../../../../../../client/state/SubscriptionOfferStore.js";
import {iFrameMerchantService} from "../../../../../services/IframeMerchantService.js";
import {TNR_ALIAS} from "../../../../../../blink-sdk/Constants.js";
import {AnalyticsEventType, dispatchAnalyticsEvent} from "../../../../../../blink-sdk/utils/AnalyticsClient.js";
import {TNRSubscriptionCoverageCard} from "./TNRSubscriptionCoverageCard.jsx";
import {SubscriptionCoverageCard} from "./SubscriptionCoverageCard.jsx";
import {Flow} from "../../../../flows/Flow.js";
import {SUBSCRIBE_PLAN_STATE} from "../../../../flows/steps/SubscriptionPlanFlowStep.js";
import {CoverageChangeType} from "../../../../../../client/state/SubscriptionCoverageStore.js";
import {SubscriptionApplyPolicy} from "../../../../../../client/state/SubscriptionStore.js";
import {isSmallScreen} from "../../../../../UtilsLib.js";

export class SubscriptionCardsListStyle extends StyleSheet {
    @styleRule
    container = {
        maxWidth: 1600,
        display: "inline-flex",
        flexWrap: "wrap",
        justifyContent: "center",
        width: "fit-content"
    }

    @styleRule
    subscriptionCard = {
        margin: isSmallScreen() ? "8px 0px" : 16,
    }
}

@registerStyle(SubscriptionCardsListStyle)
export class SubscriptionCardsList extends UI.Element {
    analyticsDispatched = false;

    async handleSubscribeClick(offer) {
        dispatchAnalyticsEvent(AnalyticsEventType.SUBSCRIPTION_SELECTED, {offerId: offer.id});

        await Flow.auth.promptIfNeeded();

        if (Flow.subscriptionPlan.subscriptionPlanState === SUBSCRIBE_PLAN_STATE.editSubscription) {
            const instantPayInfo = Flow.subscriptionPlan.getDiscountInfoOnInstantChangePolicy(offer);

            Flow.subscriptionPlan.update({
                applyPolicy: instantPayInfo?.coverageChangeType == CoverageChangeType.UPGRADE ?
                    SubscriptionApplyPolicy.INSTANTLY : SubscriptionApplyPolicy.NEXT_BILLING_CYCLE
            });
        }

        await Flow.subscriptionPlan.selectValue(offer);
    }

    render() {
        const {styleSheet} = this;

         // TODO: Have a special ordering field instead of "id".
        const subscriptionCoverages = SubscriptionOfferStore.all()
            .map(offer => offer.getCoverage())
            .filter((coverage, index, arr) => arr.indexOf(coverage) === index) // ensure unique coverages are returned
            .sort((coverage1, coverage2) => coverage1.id - coverage2.id);
        const cardEntries = [];

        // TODO @cleanup so looks like there should be an option in the panel to be per offer or grouped per coverage
        if (iFrameMerchantService.isMerchant(TNR_ALIAS)) {
            for (const offer of SubscriptionOfferStore.all()) {
                cardEntries.push({
                    coverage: offer.getCoverage(),
                    offers: [offer]
                });
            }
        } else {
            for (const coverage of subscriptionCoverages) {
                cardEntries.push({
                    coverage,
                    offers: [coverage.getAvailableOffers()]
                });
            }
        }

        if (!this.analyticsDispatched) {
            dispatchAnalyticsEvent(AnalyticsEventType.SHOW_SUBSCRIPTION_COVERAGE_CARDS, {
                coverageCards: cardEntries.map(({coverage, offers}) => ({
                    coverageId: coverage.id,
                    offerIds: offers.map(offer => offer.id),
                }))
            });
            this.analyticsDispatched = true;
        }

        const CoverageCardClass = iFrameMerchantService.isMerchant(TNR_ALIAS) ?
            TNRSubscriptionCoverageCard : SubscriptionCoverageCard;

        // TODO @cleanup just add the class to the card?
        return cardEntries.map(({offers, coverage}, index) =>
            <CoverageCardClass
                className={styleSheet.subscriptionCard}
                offer={offers[0]}
                coverage={coverage}
                bestValue={index === SubscriptionOfferStore.all().length - 1}
                onSubscriptionOfferSelected={(offer) => this.handleSubscribeClick(offer)}
            />);
    }
}